import React from 'react';

const exported = {
  nullOrUndefined(value) {
    return value == null;
  },

  niceFileName(filename: string = '') {
    let i;
    const splitName = filename.split('.');
    let name = '';

    if (splitName.length > 4) {
      let i = 3;
      if (splitName[2].startsWith('SMS')) i = 2; //hack as username seems to be missing from some SMS

      for (i; i <= splitName.length - 2; i++) {
        name += splitName[i] + '.';
      }
    } else if (splitName.length >= 2) {
      for (i = 0; i <= splitName.length - 2; i++) {
        name += splitName[i] + '.';
      }
    } else name = filename;
    if (name[name.length - 1] === '.') {
      return name.substring(0, name.length - 1);
    }
    return name;
  },

  getUserName(name) {
    const splitName = (name || '').split('.');
    if (splitName.length > 4) {
      return splitName[1];
    }
    return '';
  },

  getIcon(name) {
    let icon, type;
    const splitName = (name || '').split('.');
    if (splitName[splitName.length - 1].indexOf('wt') === 0) {
      type = splitName[splitName.length - 1].substring(2);
    } else {
      type = splitName[splitName.length - 1];
    }
    if (type === 'letter' || type === 'html') {
      icon = 'fa-file-o';
    } else if (type === 'email' || type === 'eml') {
      icon = 'fa-envelope-o';
    } else if (type === 'sms') {
      icon = 'fa-phone';
    } else if (type === 'print') {
      icon = 'fa-print';
    } else {
      icon = 'fa-file-o';
    }

    return <i className={`fa ${icon}`} />;
  },
  createThemedElement(component, props, other) {
    return React.createElement(component, props, other);
  },
  deepEqual(object1: any, object2: any) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
      return false;
    }
    for (const key of keys1) {
      const val1 = object1[key];
      const val2 = object2[key];
      const areObjects = isObject(val1) && isObject(val2);
      if (
        (areObjects && !deepEqual(JSON.stringify(val1), JSON.stringify(val2))) ||
        (!areObjects && JSON.stringify(val1) !== JSON.stringify(val2))
      ) {
        return false;
      }
    }
    return true;
  },
  isObject(object: any) {
    return object != null && typeof object === 'object';
  }
};

export default exported;

export const { nullOrUndefined, niceFileName, getUserName, getIcon, deepEqual, isObject } =
  exported;
